import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "stage" }
const _hoisted_2 = { class: "stage-inner" }
const _hoisted_3 = { class: "lead" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "login-inputs" }
const _hoisted_6 = { class: "input-wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}
const _hoisted_8 = { class: "btn-password" }
const _hoisted_9 = {
  key: 0,
  class: "error-message"
}
const _hoisted_10 = { class: "actions-btn" }
const _hoisted_11 = { class: "links" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "legal-note" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_Field = _resolveComponent("Field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_VForm = _resolveComponent("VForm")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"blobs\" aria-hidden=\"true\" data-v-b0fde688><span class=\"blob b1\" data-v-b0fde688></span><span class=\"blob b2\" data-v-b0fde688></span><span class=\"blob b3\" data-v-b0fde688></span><span class=\"blob b4\" data-v-b0fde688></span></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "kicker" }, "Rainbow Manager", -1)),
      _createElementVNode("h1", null, _toDisplayString(_ctx.t('login')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('signInLead')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_VForm, {
          "validation-schema": _ctx.formGroup,
          onSubmit: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_5, [
              _createVNode(_component_Field, { name: "email" }, {
                default: _withCtx(({ field, meta, errorMessage }) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_app_input, _mergeProps(field, {
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                      placeholder: "example@gmail.com",
                      label: "email",
                      icon: ['fas', 'envelope'],
                      error: meta.touched ? errorMessage : '',
                      type: "email"
                    }), null, 16, ["modelValue", "error"]),
                    (meta.touched && errorMessage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorValue(errorMessage)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_Field, { name: "password" }, {
                default: _withCtx(({ field, meta, errorMessage }) => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_app_input, _mergeProps(field, {
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                      placeholder: "password",
                      label: "password",
                      type: _ctx.typeInput,
                      icon: ['fas', 'lock'],
                      error: meta.touched ? errorMessage : ''
                    }), null, 16, ["modelValue", "type", "error"]),
                    _createElementVNode("div", {
                      class: "icon-eye",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleEye && _ctx.toggleEye(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: _ctx.eyeIcon }, null, 8, ["icon"])
                    ]),
                    (meta.touched && errorMessage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errorValue(errorMessage)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_app_button, {
                loading: _ctx.loading,
                type: "submit",
                title: "login"
              }, null, 8, ["loading"]),
              _createVNode(_component_app_button, {
                raised: "",
                severity: "gradient",
                title: "loginWithGoogle",
                icon: ['fab', 'google'],
                loading: _ctx.loadingGoogle,
                onClick: _cache[3] || (_cache[3] = ($event: any) => {
                $event.preventDefault();
                _ctx.loginWithGoogle();
              })
              }, null, 8, ["loading"])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "onSubmit"]),
        _createElementVNode("section", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t('forgot')), 1),
            _createVNode(_component_router_link, { to: { name: 'forgot' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('password')) + "? ", 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t('noAccount')), 1),
            _createVNode(_component_router_link, { to: { name: 'signUp' } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('signUp')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("p", _hoisted_14, [
            _createElementVNode("a", {
              href: _ctx.privacyUrl,
              target: "_blank",
              rel: "noopener"
            }, _toDisplayString(_ctx.t('privacyPolicy')), 9, _hoisted_15),
            _cache[4] || (_cache[4] = _createElementVNode("span", { "aria-hidden": "true" }, " · ", -1)),
            _createElementVNode("a", {
              href: _ctx.termsUrl,
              target: "_blank",
              rel: "noopener"
            }, _toDisplayString(_ctx.t('termsOfService')), 9, _hoisted_16)
          ])
        ])
      ])
    ])
  ]))
}